import React from 'react';

import {GenericHookPaginatedList} from 'app/components/general/lists/GenericHookPaginatedList';
import {
  convertLocationParamsToFetchParams,
  usePolicies,
} from 'app/policies/api';
import {CompactPolicyListItem} from 'app/policies/components/PoliciesDashboard/CompactPolicyListItem';
import {useUserDetails} from 'app/user/api';
import {SORT_BY_TYPES} from 'app/utils/constants';
import {gt} from 'app/utils/i18n';

import type {
  PoliciesFetchParamsType,
  PoliciesLocationParamsType,
} from 'app/policies/types';
import type {WithRouterProps} from 'react-router';
import type {DetailPolicySerializedType} from 'sweet-types';

export const PoliciesList = (routerProps: WithRouterProps) => {
  const {data: user} = useUserDetails({id: routerProps.params.userid});

  return (
    <GenericHookPaginatedList<
      DetailPolicySerializedType,
      PoliciesLocationParamsType,
      PoliciesFetchParamsType
    >
      {...routerProps}
      useDataHook={usePolicies}
      hookParams={{
        visible_to_user: routerProps.params.userid,
      }}
      convertParamsFunc={convertLocationParamsToFetchParams}
      renderItem={(policy, refresh) => (
        <CompactPolicyListItem
          object={policy}
          key={policy.id}
          toggleRelation={() => null}
          sortBy={SORT_BY_TYPES.MODIFICATION_DATE}
          refreshData={refresh}
          enableBulkSelect={false}
          isSelected={false}
          addToSelection={() => null}
          removeFromSelection={() => null}
        />
      )}
      messages={{
        notFound: ({NoResultsMessage}) => (
          <NoResultsMessage
            head={
              user?.is_guest_until != null
                ? gt('Guests have no access to policies')
                : gt("This member doesn't have access to any policies")
            }
            icon="fas fa-user-clock"
          />
        ),
      }}
    />
  );
};
